/**
 * Complete Path Item API
 * POST /api/path-items/{itemId}/complete
 *
 * Generic completion through the CompletionService funnel. Identity comes
 * from the auth token — never from the request body. Locked items are
 * rejected server-side (403 "Prerequisites not met").
 */

import axiosInstance from "../axiosInstance";

export interface PathItemCompletionRecord {
  completedAt: string;
  completedByUserId: number | null;
  completedByName: string;
  source: string;
  taskData: Record<string, unknown> | null;
}

export interface CompletePathItemResponse {
  completion: PathItemCompletionRecord;
  progress: {
    percentage: number;
    pathComplete: boolean;
  };
  alreadyCompleted: boolean;
}

interface CompletePathItemEnvelope {
  data: CompletePathItemResponse;
}

export const completePathItem = async (
  itemId: number,
  completionData?: Record<string, unknown>,
): Promise<CompletePathItemResponse> => {
  const response = await axiosInstance.post<CompletePathItemEnvelope>(
    `/api/path-items/${itemId}/complete`,
    completionData ? { completionData } : {},
  );

  return response.data.data;
};
